import { render, staticRenderFns } from "./draggableContainer.vue?vue&type=template&id=fe54a2e2"
import script from "./draggableContainer.vue?vue&type=script&lang=js"
export * from "./draggableContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports